<template>
  <SearchTools
    :searchQuery.sync="localSearchQuery"
    placeholder="Търсене по фактура, име, код на артикул"
    @do-search="$emit('search')"
    @do-clear="handleClear"
  >
    <template v-slot:prepend>
      <b-col class="pb-0" :md="dateColumnSize">
        <b-form-group>
          <FormDatepicker
            id="date-from-input"
            type="text"
            name="date_from"
            :i18n="{ placeholder: 'FORM_LABELS.DATE_FROM' }"
            :validateState="{}"
            v-model="localFilters.dateFrom"
          ></FormDatepicker>
        </b-form-group>
      </b-col>
      <b-col class="pb-0" :md="dateColumnSize">
        <b-form-group>
          <FormDatepicker
            id="date-to-input"
            type="text"
            name="date_to"
            :i18n="{ placeholder: 'FORM_LABELS.DATE_TO' }"
            :validateState="{}"
            v-model="localFilters.dateTo"
          ></FormDatepicker>
        </b-form-group>
      </b-col>
      <b-col v-if="showTypeFilter" class="pb-0" :md="4">
        <b-form-group>
          <FormSelect
            id="invoice-type-input"
            :placeholder="$t('FORM_LABELS.TYPE')"
            type="select"
            name="aiInvoiceTypeId"
            :options="invoiceTypeOptions"
            clearable="true"
            v-model="localFilters.aiInvoiceTypeId"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col class="pb-0" :md="6">
        <b-form-group>
          <FormSelect
            id="ai-supplier-input"
            :placeholder="$t('FORM_LABELS.SUPPLIER')"
            type="select"
            name="aiSupplierId"
            :options="supplierOptions"
            clearable="true"
            v-model="localFilters.aiSupplierId"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col class="pb-0" :md="6">
        <b-form-group>
          <FormSelect
            id="ai-buyer-input"
            :placeholder="$t('FORM_LABELS.BUYER')"
            type="select"
            name="aiBuyerId"
            :options="buyerOptions"
            clearable="true"
            v-model="localFilters.aiBuyerId"
          ></FormSelect>
        </b-form-group>
      </b-col>
      <b-col class="pb-0" :md="4">
        <b-form-group>
          <FormSelect
            id="is-processed-input"
            :placeholder="$t('FORM_LABELS.IS_PROCESSED')"
            type="select"
            name="isProcessed"
            :options="processedOptions"
            clearable="true"
            v-model="localFilters.isProcessed"
          />
        </b-form-group>
      </b-col>
    </template>
  </SearchTools>
</template>

<script>
import SearchTools from "@/core/components/table/SearchTools.vue";
import FormDatepicker from "@/view/content/forms/components/FormDatepicker.vue";
import FormSelect from "@/view/content/forms/components/FormSelect.vue";

export default {
  name: "InvoiceFilters",
  components: {
    SearchTools,
    FormDatepicker,
    FormSelect
  },
  props: {
    searchQuery: {
      type: String,
      default: ""
    },
    filters: {
      type: Object,
      required: true
    },
    supplierOptions: {
      type: Array,
      default: () => []
    },
    buyerOptions: {
      type: Array,
      default: () => []
    },
    invoiceTypeOptions: {
      type: Array,
      default: () => []
    },
    showTypeFilter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localSearchQuery: {
      get() {
        return this.searchQuery;
      },
      set(value) {
        this.$emit("update:searchQuery", value);
      }
    },
    localFilters: {
      get() {
        return this.filters;
      },
      set(value) {
        this.$emit("update:filters", value);
      }
    },
    dateColumnSize() {
      return this.showTypeFilter ? 4 : 6;
    },
    processedOptions() {
      return [
        { id: null, name: this.$t("LABELS.ALL") },
        { id: false, name: this.$t("LABELS.NOT_PROCESSED") },
        { id: true, name: this.$t("LABELS.PROCESSED") }
      ];
    }
  },
  methods: {
    handleClear() {
      this.localFilters.dateFrom = null;
      this.localFilters.dateTo = null;
      this.localFilters.aiSupplierId = null;
      this.localFilters.aiBuyerId = null;
      this.localFilters.aiInvoiceTypeId = null;
      this.localFilters.isProcessed = false;
      this.$emit("clear");
    }
  }
};
</script>
